import { useQuery } from '@apollo/client';
import {
  IssueTicketListFilterInput,
  IssueTicketListSortingInput,
  IssueTicketsDocument,
  IssueTicketsQuery,
  PaginationInput,
} from 'src/graphql/generated/graphql';

export const useIssueTickets = ({
  filter,
  sorting,
  pagination,
}: {
  filter: IssueTicketListFilterInput;
  sorting: IssueTicketListSortingInput;
  pagination: PaginationInput;
}) => {
  const { data, loading } = useQuery<IssueTicketsQuery>(IssueTicketsDocument, {
    variables: {
      filter,
      sorting,
      pagination: {
        limit: pagination.limit,
        offset: pagination.offset,
      },
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-and-network',
  });

  return {
    issueTickets: data?.issueTickets?.records || [],
    totalCount: data?.issueTickets?.pagination?.totalCount || 0,
    loading,
  };
};
